mutation ApprovalFlowDelete($input: ApprovalDeleteInput!) {
  approvalDelete(input: $input) {
    deletedEntities {
      id
      rowTimestamp
    }
    query {
      activeApprovalTypes(orderBy: APPROVAL_TYPE_ASC, isAllPhases: true) {
        nodes {
          id
          approvalType
          _activeCount
        }
      }
    }
  }
}
